<template>
  <AccessCodePaymentAuditPage
    accessCodePaymentType="BASIC_CLASS"
  />
</template>
<script>
import AccessCodePaymentAuditPage from "@/components/pages/AccessCodePaymentAuditPage.vue";

export default {
  components: {AccessCodePaymentAuditPage},
}
</script>
